/**
 * Fires video GTM events and adds them to a dataLayer
 * @param {object} video - the video DOM element
 * @param {array} dataLayer - the GTM data layer
 */
export const videoDataLayer = (video, dataLayer) => {
  let tick;

  video.addEventListener('timeupdate', () => {
    const duration = video.duration;

    tick = video.currentTime;
    videoHandler(tick, duration);
  });

  const cases = {
    play: false,
    quarter: false,
    half: false,
    threeFourths: false,
    complete: false,
  };

  const videoHandler = (time, duration) => {
    const roundedDuration = Math.floor(duration);
    const roundedTime = time > 1 ? Math.ceil(time) : Math.floor(time);

    switch (true) {
      case roundedTime <= 1: {
        !cases['play'] &&
          dataLayer.push({
            event: 'video action',
            category: 'Videos',
            action: 'play',
            label: video.src, // accessing the src of the <video> before the metadata has loaded
          });

        cases['play'] = true;
        break;
      }

      case roundedTime >= 0.25 * roundedDuration && roundedTime <= 0.5 * roundedDuration: {
        !cases['quarter'] &&
          dataLayer.push({
            event: 'video action',
            category: 'Videos',
            action: '25%',
            label: video.currentSrc,
          });

        cases['quarter'] = true;
        break;
      }
      case roundedTime >= 0.5 * roundedDuration && roundedTime <= 0.75 * roundedDuration: {
        !cases['half'] &&
          dataLayer.push({
            event: 'video action',
            category: 'Videos',
            action: '50%',
            label: video.currentSrc,
          });

        cases['half'] = true;
        break;
      }
      case roundedTime >= 0.75 * roundedDuration && roundedTime < roundedDuration: {
        !cases['threeFourths'] &&
          dataLayer.push({
            event: 'video action',
            category: 'Videos',
            action: '75%',
            label: video.currentSrc,
          });

        cases['threeFourths'] = true;
        break;
      }
      case roundedTime === roundedDuration: {
        !cases['complete'] &&
          dataLayer.push({
            event: 'video action',
            category: 'Videos',
            action: 'watch to end',
            label: video.currentSrc,
          });

        cases['complete'] = true;
        break;
      }
    }
  };
};
